import React, { useState } from 'react';
import PropTypes from 'prop-types';
import getBreakpointView from 'utils/getBreakpointView';
import Text from 'components/Core/Text';
import Button from 'components/Core/Button';
import { scrollToAnchor } from 'utils/sweetScroll';
import Search from 'components/Core/Search';

import { CareerHeroMobileContainer, SectionCareerHero } from './styles';

const STCareerHeroSection = ({
  backgroundImg,
  backgroundColor,
  title,
  titleColor,
  buttonTitle,
  buttonType,
  buttonLinkTo,
  copyBg,
  setSearch,
  ...otherProps
}) => {
  const [searchValue, setSearchValue] = useState(null);
  const isMobile = getBreakpointView(['xs', 'sm']);
  const mobileImage = backgroundImg?.imageMobile?.file?.url;
  const desktopImage = backgroundImg?.image?.file?.url;

  const image = !isMobile ? desktopImage : mobileImage || desktopImage;

  const handleOnChange = e => {
    setSearchValue(e.target.value);
  };

  const handleOnClick = () => {
    setSearch(searchValue);
    scrollToAnchor('#job-posts');
  };

  const heroCopy = (
    <div className="section-career-hero--copy">
      <Text type="h2" className="section-career-hero--title">
        {title}
      </Text>
      <div className="careers-hero--search-container">
        <Search onChange={handleOnChange} value={searchValue} />
        <Button
          className="section-career-hero--button"
          type="secondary"
          dataPosition="Careers Hero - CTA"
          onClick={handleOnClick}
        >
          Go
        </Button>
      </div>
    </div>
  );

  const HeroContainer = ({ children }) => (
    <SectionCareerHero
      backgroundColor={backgroundColor}
      backgroundImg={image}
      titleColor={titleColor}
      buttonType={buttonType}
      {...otherProps}
    >
      <>
        <div className="section-career-hero--container">{children}</div>
      </>
    </SectionCareerHero>
  );

  return isMobile ? (
    <>
      <CareerHeroMobileContainer background={copyBg}>
        <HeroContainer />
        {heroCopy}
      </CareerHeroMobileContainer>
    </>
  ) : (
    <HeroContainer>{heroCopy}</HeroContainer>
  );
};

STCareerHeroSection.propTypes = {
  title: PropTypes.string,
  titleColor: PropTypes.string,
  backgroundImg: PropTypes.object,
  backgroundColor: PropTypes.string,
  buttonTitle: PropTypes.string,
  buttonType: PropTypes.string,
  buttonLinkTo: PropTypes.string,
};

export default STCareerHeroSection;
